
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/imprint",
      function () {
        return require("private-next-pages/imprint.tsx");
      }
    ]);
  